import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import './PodcastCard.css';

function PodcastCard({ _id, slug, title, description, image_url, isDefault }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    // دریافت اطلاعات کاربر
    useEffect(() => {
        const userData = localStorage.getItem('currentUser');
        if (userData) {
            try {
                const user = JSON.parse(userData);
                setCurrentUser(user);
                setIsAdmin(user.role === 'admin');
            } catch (e) {
                console.error("Error parsing user:", e);
            }
        }
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm('آیا از حذف این پادکست مطمئن هستید؟')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/podcast/${id}`);
                toast.success('پادکست با موفقیت حذف شد!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (error) {
                console.error("Error deleting podcast:", error);
                toast.error('خطا در حذف پادکست');
            }
        }
    };

    let invalidImage = image_url;
    if (!invalidImage || invalidImage === "") {
        invalidImage = 'https://thecharulathapublications.com/wp-content/uploads/2022/11/book-placeholder.png';
    }

    // استفاده از slug برای لینک
    const podcastLink = slug ? `/podcast/${slug}` : `/podcast/${_id}`;

    return (
        <div className="col">
            <div className="card podcast-card p-1 shadow">
                <div className="d-flex">
                    <div className="col-5 d-flex">
                        <Link to={podcastLink}>
                            <img 
                                className="img-fluid rounded" 
                                style={{ height: '180px', objectFit: 'cover', width: '100%' }} 
                                src={invalidImage} 
                                alt={title || 'پادکست'} 
                            />
                        </Link>
                    </div>
                    <div className="col-7 ps-2">
                        <div className="mb-2">
                            <h6 className="card-title">{title || 'پادکست'}</h6>
                            {description && (
                                <p className="description-text mt-1">{description}</p>
                            )}
                            {isDefault && (
                                <span className="badge bg-primary mt-1">پیش‌فرض</span>
                            )}
                        </div>
                        <div className="d-flex gap-2 flex-wrap">
                            <Link to={podcastLink} className="btn lh-1 btn-outline-podcast">
                                🎙️ Listen
                            </Link>
                            
                            {isAdmin && (
                                <>
                                    <Link to={`/edit-podcast/${_id}`} className="btn lh-1 btn-outline-warning">
                                        ✏️ ویرایش
                                    </Link>
                                    <button className="btn lh-1 btn-outline-danger" onClick={() => handleDelete(_id)}>
                                        🗑️ حذف
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PodcastCard;